<h1 mat-dialog-title>Update filename convention</h1>
<mat-dialog-content class="dialog-body">
  <div class="family-badge" aria-label="Convention family">
    <span class="family-badge-label">Family</span>
    <span class="family-badge-value">{{ familyBadge }}</span>
  </div>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Name</mat-label>
    <input matInput [formControl]="nameControl" type="text" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="form-field">
    <mat-label>Reason</mat-label>
    <mat-select [formControl]="reasonControl">
      @for (r of selectableReasons; track r) {
        <mat-option [value]="r">{{ reasonLabel(r) }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (isOther) {
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Detail</mat-label>
      <input matInput [formControl]="detailControl" type="text" />
    </mat-form-field>
  }

  <app-range-filename-convention-editor
    [value]="rangeSeed"
    [organizationId]="data.organizationId"
    (save)="onRangeEditorSave($event)"
  ></app-range-filename-convention-editor>
</mat-dialog-content>
<mat-dialog-actions align="end" class="actions">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button
    mat-stroked-button
    type="button"
    color="buttonSuccess"
    [disabled]="!canSubmit"
    (click)="submit()"
  >
    Save
  </button>
</mat-dialog-actions>
